<template>
    <div v-if="!finish">
        <div>请输入您的密码</div>
        <el-input class="mt20" placeholder="建议使用至少两种字符组合" type="password" v-model="password" @focus="errorMessage=''">
            <template slot="prepend">
                新的密码
            </template>
        </el-input>
        <el-input class="mt20" placeholder="建议使用至少两种字符组合" type="password" v-model="conPassword" @focus="errorMessage=''">
            <template slot="prepend">
                确认密码
            </template>
        </el-input>
        <p class="danger" v-if="errorMessage">{{errorMessage}}</p>
        <el-button class="pct100 mt20" type="primary" @click="next()" :isLoading="false">确定</el-button>
        <div class="mt20">
            <p><span class="danger">*</span> 请您保管好您的账号密码，以防被不法分子利用，骗取帐号信息</p>
        </div>
    </div>
    <div v-else>
        <div class="clearfix">
            <icon-svg name="icon-chenggong" class="icon-chenggong"></icon-svg>
            <div class="cell2">
                <h1 class="mt-1">恭喜您，设置密码成功！</h1>
                <p class="lh18">请您保管好您的账号密码，以防被不法分子利用，骗取帐号信息</p>
            </div>
            <el-button class="pct100 mt20" type="primary" @click="chose">关闭</el-button>
        </div>
    </div>
</template>
<script>
import countDown from './components/countDown'
import RegExpList from '../../util/regexs'
export default {
    components: {
        countDown,
        // iconSvg
    },
    data() {
        return {
            isLoading: false,
            finish: false,
            password: '',
            conPassword: '',
            errorMessage: ''
        }
    },
    // props: ['memberSecurityInfo'],
    methods: {
        next() {
            if (this.password == '') {
                this.errorMessage = '请输入新密码！'
                return
            }
            if(RegExpList.regPassWord.test(this.password) == false){
                this.errorMessage = '请输入6-20位任意字符支付密码,不包含空格！'
                return
            }
            if (this.password !== this.conPassword) {
                this.errorMessage = '两次输入的密码不一致！'
                return
            }
            this.isLoading = true
            $.get(__consoleURL + '/api-portal/security/member/setPayPwd', {
                payPwd: this.password
            }).then(response => {
                if(!response.status){
                    this.isLoading = false
                    this.finish = true
                    this.$emit('close')
                    this.$message({
                        type: 'success',
                        message: '设置密码成功！'
                    })
                }else{
                    this.isLoading = false
                    this.$message({
                        type: 'error',
                        message: response.msg
                    })
                }
            },(err) => {
                this.isLoading = false
            })

        },
        chose(){
            this.$emit('close')
        }
    }
}
</script>
<style scoped>
.danger {
    color: #f56c6c;
}

.danger+.mt20 {
    margin-top: 0;
}

.icon-chenggong {
    width: 50px;
    height: 50px;
    color: #53c58c;
    float: left;
    margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/Payment/components/payPassword.vue